/**
 * Determinate progress bar — the F-90 import's chunk progress and the F-70
 * translation job's shared bar. One component so the two long-running
 * operations in the app cannot look like different products.
 */
export interface ProgressBarProps {
  /** 0–100. Callers clamp/round (`importPercent`, `jobPercent`). */
  percent: number;
  /** Rendered inside the bar AND used as its accessible name. */
  label: string;
}

export function ProgressBar({ percent, label }: ProgressBarProps) {
  return (
    <div
      className="progress"
      role="progressbar"
      aria-valuenow={percent}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={label}
    >
      <div className="progress-fill" style={{ width: `${percent}%` }} />
      <span className="progress-label">{label}</span>
    </div>
  );
}
